import { DotLegalCompletedPercentage } from "@dotlegal/dotlegal-ui-components";
import { Box, TableCell } from "@mui/material";
import DotLegalLink from "@common/components/dotLegalLink/DotLegalLink";
import { useTranslation } from "@localization/useTranslation";
import { useUserContext } from "../../../../auth/userContextProvider/UserContextProvider";
import { AuditGroupColumn, AuditGroupTableRow } from "./AuditGroupTable.columns";

export interface AuditGroupTableCellProps {
    column: AuditGroupColumn;
    row: AuditGroupTableRow;
    linkTo: string;
}

function AuditGroupTableCell(props: AuditGroupTableCellProps) {
    const { translateString } = useTranslation();
    const { customerName } = useUserContext();
    const row = props.row;

    switch (props.column) {
        case AuditGroupColumn.Name:
            return (
                <TableCell sx={{ minWidth: 250 }}>
                    <DotLegalLink bold linkColor={"primary"} to={props.linkTo} stopPropagation>
                        {row.name}
                    </DotLegalLink>
                </TableCell>
            );
        case AuditGroupColumn.Template:
            return <TableCell>{row.questionnaireName}</TableCell>;
        case AuditGroupColumn.Sent:
            return <TableCell>{row.sentString}</TableCell>;
        case AuditGroupColumn.Deadline:
            return <TableCell>{row.deadlineString}</TableCell>;
        case AuditGroupColumn.Responsible:
            return <TableCell>{row.responsibleName}</TableCell>;
        case AuditGroupColumn.Sender:
            return <TableCell>{row.sender ? row.sender : customerName}</TableCell>;
        case AuditGroupColumn.Recipients:
            return <TableCell align="right">{row.totalCount}</TableCell>;
        case AuditGroupColumn.Opened:
            return <TableCell align="right">{row.openedCount}</TableCell>;
        case AuditGroupColumn.Submitted:
            return <TableCell align="right">{row.submittedCount}</TableCell>;
        case AuditGroupColumn.Excluded:
            return <TableCell align="right">{row.excludedCount}</TableCell>;
        case AuditGroupColumn.Evaluation:
            return <TableCell align="right">{row.evaluationString}</TableCell>;
        case AuditGroupColumn.Progress:
            return (
                <TableCell>
                    <Box sx={{ width: 238 }}>
                        <DotLegalCompletedPercentage
                            emptyText={row.isDraft ? translateString("draft") : undefined}
                            completed={row.isDraft ? 0 : row.progress}
                        />
                    </Box>
                </TableCell>
            );
    }
}

export default AuditGroupTableCell;
